/**
 * 模态框配置
 */
export const modalConfig = {
  width: 600,
  height: 'auto' as const,
  contentPadding: { vertical: 24, horizontal: 16 },
  modalProps: { destroyOnClose: true },
};

/**
 * 模态框底部按钮配置
 */
export const getModalFooterButtons = (
  onCancel: () => void,
  onConfirm: () => void
) => [
  {
    key: 'cancel',
    text: '取消',
    type: 'default' as const,
    onClick: onCancel,
  },
  {
    key: 'confirm',
    text: '确定',
    type: 'primary' as const,
    onClick: onConfirm,
  },
];

/**
 * 获取模态框标题
 */
export const getModalTitle = (isEditing: boolean) =>
  isEditing ? '编辑资源' : '创建资源';
